import { addErrorNotification, addSuccessNotification, NotificationType, setVistaAsMemberSubscriptionPaymentProvider } from '@vista/omnichannel-components-domain';
import { extractLastDigitsFromMaskedCardNumber } from '../../../utils/extract-last-digits-from-masked-card-number';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
export const changeSubscriptionToVistaPayment = async (card, displayText, i18n, showNotificationOnSuccess = true) => {
    const { cardDetails } = card;
    const cardLastFourDigits = extractLastDigitsFromMaskedCardNumber(cardDetails.maskedCardNumber, 4);
    try {
        await setVistaAsMemberSubscriptionPaymentProvider();
        if (showNotificationOnSuccess) {
            addSuccessNotification({
                id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Success, 'change-payment-provider-to-vista'),
                messages: [
                    i18n.displayTextLabel(displayText.changePaymentProviderToVistaSucceededMessage, {
                        cardLastFourDigits
                    })
                ]
            });
        }
        return true;
    }
    catch (error) {
        const { changeSubscriptionToVistaPaymentFailedMessage } = displayText;
        addErrorNotification({
            id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Error, 'change-subscription-to-vista-payment'),
            messages: [
                i18n.displayTextLabel(changeSubscriptionToVistaPaymentFailedMessage, {
                    cardLastFourDigits
                })
            ]
        }, error);
        return false;
    }
};
